<i18n lang='yml' src='../i18n/StatusListing.yml'></i18n>
<template>
  <div>
    <div class="heading-block d-flex flex-wrap">
      <h4>{{ $t(`${object_name}.header`) }}</h4>
      
      <a class="btn btn-sm btn-success ml-auto mt-3 mt-md-0" :href="new_status_path" v-if="createNew">
        <font-awesome-icon :icon="['fa', 'plus']"/>
        {{ $t(`${object_name}.new_status`) }}
      </a>
    </div>
    <h5 class="margin-top heading-page">{{ $t(`${object_name}.subheader`) }}</h5>
    <p class="border-bottom">{{ $t(`${object_name}.info`) }}</p>

    <h4 v-if="loadingError">{{ $t('loading_error') }}</h4>
    <div v-else class="content-block" :key="status.id" v-for="status in parsedStatuses">
      <div class="post-meta">
        <ul class="list-inline list-annotation">
          <li class="list-inline-item">
            <h4 class="container-item-name" v-if="createNew">
              <a :href="`${object_name}/${status.id}/edit`">{{status.name[locale]}}</a>
            </h4>
            <h4 class="container-item-name" v-else>
              {{status.name[locale]}}
            </h4>
          </li>
        </ul>
      </div>
      <div class="post-meta">
        <ul class="list-unstyled list-inline list-annotation">
          <li class="list-inline-item">
            <font-awesome-icon :icon="['far', 'clock']"/>
            {{ formatDate(status.created_at) }}
          </li>
          <li class="list-inline-item" v-if="status['active']">
            <font-awesome-icon :icon="['fa', 'check']"/>
            {{ $t('active') }}
          </li>
          <li class="list-inline-item" v-else-if="status['active'] == false">
            <font-awesome-icon :icon="['fa', 'times']"/>
            {{ $t('inactive') }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['locale', 'new_status_path', 'statuses', 'object_name', 'create_new'],
    data() {
      return {
        parsedStatuses: [],
        loadingError: false,
        createNew: true
      }
    },
    mounted() {
      try {
        this.parsedStatuses = JSON.parse(this.statuses) || []
        this.createNew = JSON.parse(this.create_new);
      }
      catch {
        this.loadingError = true;
      }
    },
    methods: {
      //TODO: Revisit to standardize
      // Used for turning our system dates into a standard human readable format
      formatDate(dateString) {
        var date = new Date(dateString);
        return date.toLocaleString('default', { day: 'numeric', month: 'short', year: 'numeric' });
      }
    }

  }
</script>  
